var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-detail"},[(_vm.articleId)?_c('ViewArticle',{attrs:{"catalogAlisa":_vm.catalogAlisa,"articleId":_vm.articleId,"hiddenTitle":true,"breadcrumbs":[
      { text: '首页', to: '/' },
      { text: '技能培训', to: '/skillTrain' },
      { text: '师资培训', to: '/skillTrain/teacherTraining' }
    ]}}):_vm._e(),(_vm.loadFinished && !_vm.loadError && !_vm.articleId)?_c('UiEmpty'):_vm._e(),(_vm.loadFinished && _vm.loadError)?_c('UiEmpty',{attrs:{"type":"error"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }